'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

// Mock for react-intl so that we can use extract-react-intl-messages
// with react-intl itself
// This is symlinked to node_modules during installation
function defineMessages(messageDescriptors) {
  // This simply returns what's passed-in because it's meant to be a hook for
  // babel-plugin-react-intl.
  return messageDescriptors;
}
var defineMessages_2 = defineMessages;
var defineMessages_1 = {
  defineMessages: defineMessages_2
};

exports["default"] = defineMessages_1;
exports.defineMessages = defineMessages_2;
//# sourceMappingURL=defineMessages.js.map
